import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExploreComponent } from './pages/explore/explore.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { AuthGuard } from '../auth/auth.guard';
import { MasterComponent } from '../layout/pages/master/master.component';
import { SearchComponent } from './pages/search/search.component';

const routes: Routes = [
  {
    path: 'explore',
    component: MasterComponent,
    canActivate: [AuthGuard],
    data: {
      'showHeader': true
    },
    children: [
      {
        path: '',
        component: CategoriesComponent
      },
      {
        path: ':category',
        component: ExploreComponent
      },
      {
        path: 'search/:query',
        component: SearchComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExploreRoutingModule { }
